import request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 访客记录
   */
  static getRecordList(data) {
    return request({
      url: 'visitor/record/list',
      host: config.HOST_PROMOTE,
      method: 'post_json',
      ignore401: true,
      data
    });
  }
  /**
   * getShareId
   */
  static getShareId(data) {
    return request({
      url: 'visitor/share/record/share',
      host: config.HOST_PROMOTE,
      method: 'post_json',
      ignore401: true,
      data
    });
  }

  /**
   * 访客埋点
   */
  static injectVistor(data) {
    return request({
      url: 'visitor/record/visitor',
      host: config.HOST_PROMOTE,
      method: 'post_json',
      ignore401: true,
      data
    });
  }

  /**
   * 获取优惠券数量
   */
  static getCouponData() {
    return request({
      url: `coupon/couponCountByRemind`,
      host: config.HOST_MALL,
      method: 'post_json'
    });
  }

  /**
   * 获取秒杀-即将开始的数据
   */
  static getSeckillWill(params) {
    return request({
      url: `promotion/queryDisplayActivity`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 获取绑定权益共享卡信息
   */
  static getEquityCard(params) {
    return request({
      url: `equityCard/dobind`,
      method: 'post_json',
      host: config.HOST_MALL,
      data: params,
      ignoreErr: true
    });
  }

  /**
   * 获取专题页信息
   */
  static getrRcommendPageInfo(params) {
    return request({
      url: 'content/recommandUi/recommendPageInfo',
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 获取服务器时间
   */
  static getrServerTime(params) {
    return request({
      url: 'basic/common/server',
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 悬浮窗数据
   */
  static getFloatWindow() {
    return request({
      url: 'content/recommandUi/window',
      host: config.HOST_MALL
    });
  }

  /**
   * banner位置数据
   */
  static getBanner() {
    return request({
      url: `content/recommandUi/banner/1/2`,
      host: config.HOST_MALL
    });
  }

  /**
   * 获取首页背景图
   */
  static getBackground() {
    return request({
      url: `content/recommandUi/indexBackground/1/2`,
      host: config.HOST_MALL
    });
  }

  /**
   *
   */

  static getImgAverageColor(imgUrl) {
    return request({
      url: `${imgUrl}?x-image-process=image/average-hue`,
      method: 'get',
      withCredentials: false,
      ignoreErr: true
      // host: config.HOST_MALL,
    });
  }

  /**
   * 固定按钮位置
   */
  static getButtonList() {
    return request({
      url: 'content/recommandUi/button/1/2',
      host: config.HOST_MALL
    });
  }

  /**
   * 应用位数据
   */
  static getApplication() {
    return request({
      url: 'content/recommandUi/application',
      host: config.HOST_MALL
    });
  }

  /**
   * 获取工作室类型列表
   */
  static getStoreTypeList(params) {
    return request({
      url: `store_type/list`,
      host: config.HOST_STORE,
      params
    });
  }

  /**
   * 获取体系区域配置情况
   */
  static getRegionConfiguration(params) {
    return request({
      url: `store_type/validate/occupancy`,
      host: config.HOST_STORE,
      params,
      method: 'post'
    });
  }

  /**
   * 检验卡号是否有效
   */
  static verifyMemberCardValid(params) {
    return request({
      url: 'store/create/checkMemberCardValid',
      host: config.HOST_STORE,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 检验卡号是否有效V2
   */
  static verifyMemberCardValidV2({ ignoreErr = false, jointCreationTag = 0 } = {}) {
    return request({
      url: 'store/create/checkMemberCardValid',
      host: config.HOST_STORE,
      method: 'post_json',
      ignoreErr,
      data: {
        jointCreationTag
      }
    });
  }

  /**
   * 检查联创代理信息
   */
  static checkLianChuangProxy(ignoreErr = false) {
    return request({
      url: 'lianchuang/checkLianChuangProxy',
      host: config.HOST_STORE,
      method: 'post_json',
      data: {},
      ignoreErr
    });
  }

  /**
   * 资讯位数据
   */
  static getNews() {
    return request({
      url: 'content/article/getLateThree?source=0',
      host: config.HOST_MALL
    });
  }

  /**
   * 推荐位数据
   */
  static getRecommender() {
    return request({
      url: `content/recommandUi/recommand/1/2`,
      host: config.HOST_MALL
    });
  }

  /**
   * 推荐位数据
   */
  static getCarousel() {
    return request({
      url: `content/recommandUi/rotation/1/2`,
      host: config.HOST_MALL
    });
  }

  /**
   * 三位图数据
   */
  static getThreeImgs() {
    return request({
      url: 'content/recommandUi/three/1/2',
      host: config.HOST_MALL
    });
  }

  /**
   * 图文推荐数据
   */
  static getImgText() {
    return request({
      url: 'content/recommandUi/imagesText/1/2',
      host: config.HOST_MALL
    });
  }

  /**
   * 分类推荐数据
   */
  static getClassify() {
    return request({
      url: 'content/recommandUi/classify/1/2',
      host: config.HOST_MALL
    });
  }

  /**
   * 广告图数据
   */
  static getAdvPicture() {
    return request({
      url: 'content/recommandUi/adPicture/1/2',
      host: config.HOST_MALL
    });
  }

  /**
   * 产品楼层数据
   */
  static getProductFloor() {
    return request({
      url: 'content/recommandUi/itemFloor/1/2',
      host: config.HOST_MALL
    });
  }

  /**
   * 标题数据
   */
  static getTitleGuide() {
    return request({
      url: 'content/recommandUi/title/1/2',
      host: config.HOST_MALL
    });
  }

  /**
   * 健康时刻表数据
   */
  static getHealthTimeLine() {
    return request({
      url: 'content/recommandUi/queryRecommandBitUiHour',
      host: config.HOST_MALL
    });
  }

  /**
   * 产品推荐数据
   */
  static getRecommendProduct() {
    return request({
      url: 'content/recommandUi/itemGrid/1/2',
      host: config.HOST_MALL
    });
  }

  /**
   * 查询活动列表
   */
  static getQueryActiveActivityList(data) {
    return request({
      url: 'my/promotion/queryActiveActivity',
      host: config.HOST_MALL,
      method: 'post_json',
      ignore401: true,
      data
    });
  }

  /**
   * 查询资格购活动列表
   */
  static getQualificationList(data) {
    return request({
      url: 'promotion/queryActiveActivity/qualification/validate',
      host: config.HOST_MALL,
      method: 'post_json',
      ignore401: true,
      data
    });
  }

  /**
   * 查询是否可开实体卡或虚拟卡
   */
  static queryCanApplyType(params) {
    return request({
      url: 'user/register/checkOpenCardAttribute',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 查询是否为一级分类
   */
  static checkFirstCateGory(id) {
    return request({
      url: `item/catalog/dirId/front/${id}`,
      host: config.HOST_MALL,
      method: 'get'
    });
  }

  /**
   * 移动端新人下载套餐广告
   */

  static queryNewcomer() {
    return request({
      url: 'content/newcomer/queryNewcomer',
      host: config.HOST_MALL,
      method: 'get'
    });
  }

  /**
   * 获取生日信息
   */
  static fetchBirthdayInfo() {
    return request({
      url: 'content/homePageAdUi',
      host: config.HOST_MALL,
      method: 'get'
    });
  }

  // 提交累计信息
  static accumulateUserInfo(params) {
    const status = 1;
    return request({
      url: `user/info/accumulateUserInfo/${status}`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 查询当前用户是否是生日
   */
  static checkBirthday(url) {
    return request({
      url,
      host: config.HOST_MALL,
      method: 'post_json',
      ignoreErr: true
    });
  }
  /*
   * 查询专题详情
   */
  static getThematicDetail(params) {
    return request({
      url: 'progress/learning/thematic/detail',
      host: config.HOST_PROMOTE,
      method: 'get',
      params
    });
  }
  /**
   * 获取直播列表
   */
  static getLiveList(params) {
    return request({
      url: `https://api.yofolive.com/api/thirdpart/live/list?currentPage=1&pageRecords=1000000&appid=`,
      host: '',
      method: 'get'
    });
  }

  /**
   * 获取活动信息
   */
  static getActivityInfo(activityId) {
    return request({
      url: `promotion/activity/id/${activityId}`,
      host: config.HOST_MALL,
      method: 'get'
    });
  }

  /**
   * 获取用户支持的配货比例
   */
  static getUserdistriBution(params) {
    return request({
      url: 'biz/tradecore/trade/query/distribution-rate',
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 获取用户可续费的优惠券
   */
  static getDelayList() {
    return request({
      url: 'coupon/queryDelayList',
      host: config.HOST_MALL
      // params
    });
  }

  // 升级 - 查询卡类型
  static queryCardType(params) {
    return request({
      url: 'user/upgrade/queryCardType',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  static getDelayCoupon(params) {
    return request({
      url: 'coupon/delayCoupon',
      host: config.HOST_MALL,
      method: 'POST',
      params
    });
  }

  /**
   * 获取用权限点
   */
  static getGongSiEnterList() {
    return request({
      url: `user/info/getGongSiEnterList`,
      host: config.HOST_MALL,
      method: 'GET'
    });
  }

  /**
   * 获取用权限点
   */
  static getEnterList() {
    return request({
      url: `user/info/getEnterList`,
      host: config.HOST_MALL
    });
  }

  static getUpgradeRecent() {
    return request({
      url: `lifecycle/remind`,
      host: config.HOST_MALL,
      method: 'get',
      data: {}
    });
  }
  // 保存弹窗显示记录
  static savePopupRecord(params) {
    return request({
      url: `content/recommand/popup/record/save`,
      host: config.HOST_MALL,
      method: 'post_json',
      ignoreErr: true,
      data: params
    });
  }
  // 获取移动端活动广告弹窗
  static getActiveAdList(params) {
    return request({
      url: `content/recommand/popup/show`,
      host: config.HOST_MALL,
      method: 'post_json',
      ignoreErr: true,
      data: params
    });
  }
  // 抽奖活动详情
  static getDrawSetting(params) {
    return request({
      url: 'draw/detail',
      host: config.HOST_MALL,
      method: 'GET',
      params
    });
  }
  // 查询是否真实开始下红包雨
  static hongbaoyuStart(params) {
    return request({
      url: 'honghaoyu/start',
      host: config.HOST_MALL,
      method: 'GET',
      params,
      ignoreErr: true
    });
  }
  // 点击红包雨
  static drawStart(params) {
    return request({
      url: 'honghaoyu/clickHongBaoYu',
      host: config.HOST_MALL,
      method: 'GET',
      params,
      ignoreErr: true
    });
  }
  // 红包雨点击后的返回列表
  static drawList(params) {
    return request({
      url: 'draw/records/hongbaoyu',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params,
      ignoreErr: true
    });
  }

  /**
   * 获取权益 + 特权配置
   */
  static getRightsSetting() {
    return request({
      url: 'member/rights/queryPresent',
      host: config.HOST_MALL
    });
  }

  // 获取悬浮条数据
  static queryRepeatPrompt() {
    return request({
      url: 'personal/queryRepeatPrompt',
      host: config.HOST_MALL
    });
  }

  // 热卖宫格
  static getHotRecommend() {
    return request({
      url: 'content/recommandUi/hotSaleItem/1/2',
      host: config.HOST_MALL
    });
  }

  // 获取蜂鸟静默登录参数
  static getFengniaoCode() {
    return request({
      url: 'user/fn/silent/code',
      host: config.HOST_MALL
    });
  }

  // 同步乐道小程序用户信息
  static syncLd() {
    return request({
      url: 'c3tech/sync',
      method: 'post_json',
      host: config.HOST_MALL
    });
  }

  // 获取线上地址的店铺信息
  static getLinkStoreInfo(userId) {
    return request({
      url: `content/recommandUi/storeInfo?userId=${userId}`,
      host: config.HOST_MALL,
      method: 'GET'
    });
  }

  // 获取店铺信息
  static getStoreInfo() {
    return request({
      url: 'content/recommandUi/storeInfo/1/2',
      host: config.HOST_MALL
    });
  }

  static getEquityInfo(params) {
    return request({
      url: 'rightsInfo/queryRightsInfo',
      host: config.HOST_PROMOTE,
      params
    });
  }

  static recordRead(params) {
    return request({
      url: 'rights/read/record/hasRead',
      host: config.HOST_PROMOTE,
      method: 'post_json',
      data: params
    });
  }

  static getCombinedRecommend() {
    return request({
      url: 'content/recommandUi/combo/1/2',
      host: config.HOST_MALL
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Home/ShopHome/ShopHomeServ.js